export const blogPosts = [
  {
    id: "advances-in-drug-delivery-systems-2024",
    title: "Advances in Drug Delivery Systems in 2024",
    excerpt: "Exploring the latest innovations in pharmaceutical drug delivery technologies and their impact on patient care.",
    content: `
      <p class="mb-6 text-lg leading-relaxed">Drug delivery innovation has accelerated rapidly in 2024, with breakthrough technologies enhancing therapeutic efficacy and patient experience.</p>
      
      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Key Innovations in Drug Delivery</h2>
      <p class="mb-4 text-lg leading-relaxed">Several groundbreaking technologies are transforming how medications reach their targets:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Nanotechnology-based targeted delivery</li>
        <li>Smart implantable devices</li>
        <li>3D-printed personalized dosage forms</li>
        <li>Extended-release formulation advances</li>
      </ul>

      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Impact on Patient Care</h2>
      <p class="mb-4 text-lg leading-relaxed">These advances are significantly improving patient outcomes through:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Enhanced bioavailability of medications</li>
        <li>Reduced dosing frequency and improved adherence</li>
        <li>Minimized side effects through targeted action</li>
        <li>Expanded treatment options for complex conditions</li>
      </ul>
    `,
    date: "March 15, 2024",
    category: "R&D",
    readTime: "5 min read",
    author: "Dr. Sarah Chen",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    tags: ["Drug Delivery", "Innovation", "R&D", "Patient Care"]
  },
  {
    id: "digital-transformation-pharmaceutical-industry",
    title: "Digital Transformation in the Pharmaceutical Industry",
    excerpt: "How AI, blockchain, and data analytics are revolutionizing pharmaceutical development, manufacturing, and patient care.",
    content: `
      <p class="mb-6 text-lg leading-relaxed">The pharmaceutical industry is experiencing unprecedented digital transformation, enhancing drug discovery, manufacturing processes, and personalized medicine approaches.</p>
      
      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Emerging Technologies in Pharma</h2>
      <p class="mb-4 text-lg leading-relaxed">Several technologies are reshaping the pharmaceutical landscape:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>AI-powered drug discovery platforms</li>
        <li>Machine learning for clinical trial optimization</li>
        <li>Blockchain for supply chain transparency</li>
        <li>Digital twins for manufacturing processes</li>
      </ul>

      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Benefits of Digital Transformation</h2>
      <p class="mb-4 text-lg leading-relaxed">The advantages of embracing digital solutions include:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Accelerated drug development timelines</li>
        <li>Enhanced manufacturing efficiency and quality</li>
        <li>Improved regulatory compliance management</li>
        <li>Data-driven decision making across operations</li>
      </ul>
    `,
    date: "March 10, 2024",
    category: "Technology",
    readTime: "4 min read",
    author: "Dr. Sarah Chen",
    image: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    tags: ["Technology", "Digital Transformation", "Pharmaceuticals", "Innovation"]
  },
  {
    id: "sustainability-pharmaceutical-manufacturing",
    title: "Sustainable Practices in Pharmaceutical Manufacturing",
    excerpt: "How the industry is implementing green chemistry, reducing waste, and embracing sustainable manufacturing practices.",
    content: `
      <p class="mb-6 text-lg leading-relaxed">Sustainable manufacturing has become a priority for forward-thinking pharmaceutical companies, addressing environmental impacts while maintaining high quality standards.</p>
      
      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Key Sustainability Initiatives</h2>
      <p class="mb-4 text-lg leading-relaxed">Leading pharmaceutical manufacturers are focusing on:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Green chemistry principles in drug synthesis</li>
        <li>Water conservation and recycling programs</li>
        <li>Renewable energy implementation</li>
        <li>Packaging waste reduction strategies</li>
      </ul>

      <h2 class="text-2xl font-bold text-[#1A1A1A] mt-8 mb-4">Benefits of Sustainable Manufacturing</h2>
      <p class="mb-4 text-lg leading-relaxed">Companies embracing sustainability are seeing multiple advantages:</p>
      <ul class="list-disc pl-6 mb-6 space-y-2 text-lg">
        <li>Reduced environmental footprint</li>
        <li>Lower operational costs</li>
        <li>Enhanced corporate reputation</li>
        <li>Regulatory compliance advantages</li>
      </ul>
    `,
    date: "March 5, 2024",
    category: "Manufacturing",
    readTime: "6 min read",
    author: "Dr. Sarah Chen",
    image: "https://images.unsplash.com/photo-1518972559570-7cc1309f3229?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80",
    tags: ["Sustainability", "Manufacturing", "Green Chemistry", "Environmental Impact"]
  }
]; 